export default __webpack_public_path__ + "static/media/book11.4ea6412b.svg";